import AsyncStorage from "@react-native-async-storage/async-storage";
import React, { useEffect, useState } from "react";
import {
  ActivityIndicator,
  Alert,
  Appearance,
  Pressable,
  SafeAreaView,
  StyleSheet,
  Text,
  TextInput,
  useColorScheme,
  View,
} from "react-native";
import { supabase } from "../services/supabase";
import { useRouter } from "expo-router";

const THEME_STORAGE_KEY = "app_theme";

export default function TelaLogin() {
  const router = useRouter();
  const systemScheme = useColorScheme();
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [carregando, setCarregando] = useState(false);
  const [modoEscuro, setModoEscuro] = useState(systemScheme === "dark");

  useEffect(() => {
    async function carregarTema() {
      try {
        const temaSalvo = await AsyncStorage.getItem(THEME_STORAGE_KEY);
        if (temaSalvo === "light" || temaSalvo === "dark") {
          setModoEscuro(temaSalvo === "dark");
        } else {
          setModoEscuro(systemScheme === "dark");
        }
      } catch (error) {
        console.warn("Erro ao carregar tema no login:", error);
      }
    }
    carregarTema();
  }, [systemScheme]);

  async function handleLogin() {
    if (!email.trim() || !senha.trim()) {
      Alert.alert("Campos obrigatórios", "Por favor, preencha o e-mail e a senha.");
      return;
    }

    setCarregando(true);
    try {
      const { error } = await supabase.auth.signInWithPassword({
        email: email.trim(),
        password: senha,
      });

      if (error) {
        Alert.alert("Falha no login", error.message);
      } else {
        // Redireciona para a tela inicial
        router.replace("/");
      }
    } catch (err) {
      Alert.alert(
        "Erro",
        err instanceof Error ? err.message : "Ocorreu um erro ao tentar entrar."
      );
    } finally {
      setCarregando(false);
    }
  }

  return (
    <SafeAreaView style={[styles.container, modoEscuro && styles.containerDark]}>
      <View style={styles.content}>
        <View style={[styles.card, modoEscuro && styles.cardDark]}>
          <Text style={[styles.title, modoEscuro && styles.titleDark]}>
            Açaí do Casal20
          </Text>
          <Text style={[styles.subtitle, modoEscuro && styles.subtitleDark]}>
            Entre com suas credenciais para gerenciar suas comandas e produtos.
          </Text>

          <View style={styles.fieldGroup}>
            <Text style={[styles.label, modoEscuro && styles.textDark]}>
              E-mail
            </Text>
            <TextInput
              value={email}
              onChangeText={setEmail}
              placeholder="seu-email@dominio.com"
              style={[styles.input, modoEscuro && styles.inputDark]}
              placeholderTextColor={modoEscuro ? "#9ca3af" : "#6b7280"}
              autoCapitalize="none"
              autoCorrect={false}
              keyboardType="email-address"
            />
          </View>

          <View style={styles.fieldGroup}>
            <Text style={[styles.label, modoEscuro && styles.textDark]}>
              Senha
            </Text>
            <TextInput
              value={senha}
              onChangeText={setSenha}
              placeholder="Digite sua senha"
              style={[styles.input, modoEscuro && styles.inputDark]}
              placeholderTextColor={modoEscuro ? "#9ca3af" : "#6b7280"}
              autoCapitalize="none"
              autoCorrect={false}
              secureTextEntry
            />
          </View>

          <Pressable
            style={[styles.button, carregando && styles.buttonDisabled]}
            onPress={handleLogin}
            disabled={carregando}
          >
            {carregando ? (
              <ActivityIndicator size="small" color="#fff" />
            ) : (
              <Text style={styles.buttonText}>Entrar</Text>
            )}
          </Pressable>
        </View>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#f5f5f5",
  },
  containerDark: {
    backgroundColor: "#0f172a",
  },
  content: {
    flex: 1,
    justifyContent: "center",
    padding: 20,
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: 16,
    padding: 20,
    borderWidth: 1,
    borderColor: "#e5e7eb",
  },
  cardDark: {
    backgroundColor: "#111827",
    borderColor: "#374151",
  },
  title: {
    fontSize: 26,
    fontWeight: "800",
    color: "#111827",
    marginBottom: 6,
    textAlign: "center",
  },
  titleDark: {
    color: "#f9fafb",
  },
  subtitle: {
    fontSize: 14,
    color: "#6b7280",
    marginBottom: 24,
    lineHeight: 20,
    textAlign: "center",
  },
  subtitleDark: {
    color: "#d1d5db",
  },
  fieldGroup: {
    marginBottom: 16,
  },
  label: {
    fontSize: 13,
    fontWeight: "700",
    color: "#374151",
    marginBottom: 8,
  },
  textDark: {
    color: "#e5e7eb",
  },
  input: {
    backgroundColor: "#f9fafb",
    borderWidth: 1,
    borderColor: "#d1d5db",
    borderRadius: 10,
    paddingHorizontal: 12,
    paddingVertical: 12,
    fontSize: 15,
    color: "#111827",
  },
  inputDark: {
    backgroundColor: "#1f2937",
    borderColor: "#374151",
    color: "#f9fafb",
  },
  button: {
    backgroundColor: "#2563eb",
    borderRadius: 10,
    paddingVertical: 14,
    alignItems: "center",
    justifyContent: "center",
    marginTop: 8,
  },
  buttonDisabled: {
    opacity: 0.7,
  },
  buttonText: {
    color: "#fff",
    fontSize: 15,
    fontWeight: "700",
  },
});
